module.exports = __webpack_public_path__ + "static/media/xs-anonymous.2c0f82da.svg";